document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initGaleriaProducto();
  initVariantesProducto();
});

function initGaleriaProducto() {
  var secciones = document.querySelectorAll('[data-mt-producto]');
  secciones.forEach(function (seccion) {
    var principal = seccion.querySelector('.mt-producto-img-principal img');
    var thumbs = seccion.querySelectorAll('[data-mt-thumb]');
    if (!principal || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-mt-full');
        if (full) principal.setAttribute('src', full);
        thumbs.forEach(function (t) { t.classList.remove('mt-activa'); });
        thumb.classList.add('mt-activa');
      });
    });
  });
}

function initVariantesProducto() {
  var secciones = document.querySelectorAll('[data-mt-producto]');
  secciones.forEach(function (seccion) {
    var script = seccion.querySelector('[data-mt-variantes]');
    var form = seccion.querySelector('[data-mt-form]');
    if (!script || !form) return;

    var variantes;
    try {
      variantes = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('[data-mt-variant-id]');
    var precioEl = seccion.querySelector('[data-mt-precio]');
    var precioAntesEl = seccion.querySelector('[data-mt-precio-antes]');
    var addBtn = seccion.querySelector('[data-mt-add-btn]');
    var addTexto = seccion.querySelector('[data-mt-add-texto]');
    var pills = seccion.querySelectorAll('[data-mt-opcion]');

    var seleccion = {};
    pills.forEach(function (pill) {
      if (pill.classList.contains('mt-activa')) {
        seleccion[pill.getAttribute('data-mt-opcion')] = pill.getAttribute('data-mt-valor');
      }
    });

    function formatoMoneda(monto) {
      var numero = Math.round(parseFloat(monto));
      return numero.toLocaleString('es-CO') + ' COP';
    }

    function encontrarVariante() {
      return variantes.find(function (v) {
        return Object.keys(seleccion).every(function (pos) {
          var key = 'option' + pos;
          return v[key] === seleccion[pos];
        });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatoMoneda(variante.compare_at_price);
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (variante.available) {
          addBtn.removeAttribute('disabled');
          if (addTexto) addTexto.textContent = addBtn.getAttribute('data-mt-texto-disponible') || addTexto.textContent;
        } else {
          addBtn.setAttribute('disabled', 'disabled');
          if (addTexto) addTexto.textContent = addBtn.getAttribute('data-mt-texto-agotado') || 'Agotado';
        }
      }
      pills.forEach(function (pill) {
        var pos = pill.getAttribute('data-mt-opcion');
        var esSeleccionada = seleccion[pos] === pill.getAttribute('data-mt-valor');
        pill.classList.toggle('mt-activa', esSeleccionada);
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var pos = pill.getAttribute('data-mt-opcion');
        seleccion[pos] = pill.getAttribute('data-mt-valor');
        actualizar();
      });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.textContent = el.getAttribute('data-mt-countup'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-mt-countup')) || 0;
        var suffix = el.getAttribute('data-mt-suffix') || '';
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = Math.round(target * eased);
          el.textContent = value + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}
